import React from 'react';
import { VideoCategoryKey } from './utils';

interface WatchEmptyStateProps {
  category: VideoCategoryKey;
  hasOtherVideos: boolean;
  onSelectCategory: (category: VideoCategoryKey) => void;
}

export function WatchEmptyState({
  category,
  hasOtherVideos,
  onSelectCategory,
}: WatchEmptyStateProps): React.JSX.Element {
  const canWatchLatest = category !== 'All' && hasOtherVideos;

  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1" role="status">
      <p className="m-0 text-sm leading-snug text-[#5b7292]">
        {canWatchLatest ? 'No videos in this category.' : 'New Benzinga TV videos will show up here.'}
      </p>
      {canWatchLatest ? (
        <button
          className="inline-flex min-h-11 cursor-pointer items-center border-0 bg-transparent p-0 text-sm font-semibold text-[#1979ff] transition-colors duration-150 hover:text-[#1568db] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1979ff]"
          onClick={() => onSelectCategory('All')}
          type="button"
        >
          View all videos
        </button>
      ) : null}
    </div>
  );
}
